module.exports = __webpack_public_path__ + "media/iron_xylophone.9f0ae0bd.ogg";